<script setup lang="ts">
import AppToast from '@/components/ui/AppToast.vue'
</script>

<template>
  <div class="min-h-screen bg-bg-secondary flex flex-col items-center justify-center p-4">
    <!-- Logo / Brand -->
    <div class="mb-8 flex items-center gap-3">
      <div
        class="w-10 h-10 bg-primary rounded-md flex items-center justify-center"
        aria-hidden="true"
      >
        <span class="text-white text-lg font-bold">P</span>
      </div>
      <span class="text-xl font-semibold text-text-primary">Postlytics Admin</span>
    </div>

    <!-- Card container -->
    <div
      class="w-full max-w-md bg-bg-primary rounded-lg shadow-md border border-border p-6"
      data-testid="auth-layout-card"
    >
      <RouterView />
    </div>

    <!-- Footer -->
    <p class="mt-8 text-xs text-text-muted">
      Postlytics Admin Panel
    </p>

    <!-- Global overlays -->
    <AppToast />
  </div>
</template>
